import { useAuth } from '../hooks';
import { Home, Login,Signup, Settings, Page404, UserProfile } from '../pages';
import { Loader, Navbar } from './';
import {Routes, Route,useNavigate} from 'react-router-dom';
import { useEffect } from 'react';

function ProtectedRoute(props) {
  const auth = useAuth();
  const { Component } = props;
  const Navigate = useNavigate();
  useEffect(() => {
    if (!auth.user) {
      Navigate("/login");
    }
  });
  return <Component />;
}

function App() {
  const auth = useAuth();
  // console.log('auth', auth);
  if(auth.loading){
    return <Loader />
  }
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Signup />} />
        {/* <Route path="/settings" element={<Settings />} /> */}
        <Route
            path="/settings"
            element={<ProtectedRoute Component={Settings} />}>
        </Route>
        <Route
            path="/user/:userId"
            element={<ProtectedRoute Component={UserProfile} />}>
        </Route>
        <Route path='/*' element={<Page404 />} />

      </Routes>
      
    </div>
  );
}

export default App;
